var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader!../../node_modules/.12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5c6603ea\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../node_modules/.12.2.2@vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var Component = require("!../../node_modules/.12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.12.2.2@vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../node_modules/.12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5c6603ea\",\"hasScoped\":false}!../../node_modules/.12.2.2@vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "E:\\node_pro\\vue-component-elementUI\\message\\example\\src\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c6603ea", Component.options)
  } else {
    hotAPI.reload("data-v-5c6603ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./example/src/App.vue
// module id = 4
// module chunks = 0